module.exports = __webpack_public_path__ + "media/images/riders/EVA_LECHNER-883455d0aa6cb7b9832371ec31224165.png";